import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.h3`
  ${({ theme }) => css`
    align-items: center;
    color: ${theme.v2.colors.brand.menuPrimaryDark};
    display: flex;
    font-size: ${theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.bold};
    gap: 10px;
    margin: 0;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      align-items: flex-start;
      font-size: ${theme.v2.font.sizes.xs};
    }
  `}
`;

export const IconMaia = styled.img`
  ${({ theme }) => css`
    height: 32px;
    width: 32px;
  
    @media (max-width: ${theme.v2.breakpoints.sm}) {
      height: 20px;
      width: 20px;
    }
  `}
`;

export const Subtitle = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-size: ${theme.v2.font.sizes.xs};
    gap: 4px;
    margin: 24px 0 16px;

    & span {
      display: inline;
      position: relative;
      margin-left: 4px;
      
      svg {
        position: absolute;
        top: 2px;
      }
    }
  `};
`;

export const SampleText = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-size: ${theme.v2.font.sizes.xs};
    margin: 0;
    margin-top: 8px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `};
`;

export const SmallText = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowMedium};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    margin-left: 8px;
  `};
`;

export const ContactInfosTitle = styled.h4`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    margin: 0;
    margin-top: 32px;
  `};
`;

export const IputsListContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: 24px;
    width: 100%;
    margin: 24px 0 32px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      flex-direction: column;
    }
  `};
`;

export const InputContainerPhone = styled.div`
  ${({ theme }) => css`
    width: 40%;
  
    @media (max-width: ${theme.v2.breakpoints.md}) {
      width: 100%;
    }
  `}
`;

export const InputContainerEmail = styled.div`
  ${({ theme }) => css`
    width: 56%;
  
    @media (max-width: ${theme.v2.breakpoints.md}) {
      width: 100%;
    }
  `}
`;

export const ButtonWrapper = styled.div`
  ${({ theme }) => css`
    margin-bottom: 40px;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      > span {
        max-width: none;
      }
    }
  `};
`;

export const ButtonIconContainer = styled.div`
  margin-top: 4px;
`;
